import React, { PureComponent } from 'react';
import { Marker } from 'react-leaflet';

import { sortByKey } from '~/core/scripts/utils';

const MARKER_SIZE = 20;

class RankingMarker extends PureComponent {
  render() {
    const { selectedParty, data } = this.props;
    const isOthers = selectedParty === 'Sonst.';

    if (!selectedParty) {
      return null;
    }

    const topTenAreas = data.features
      .map(feat => ({
        value: isOthers ? feat.properties.othersItem.valueRel : feat.properties[selectedParty],
        centroid: feat.properties.centroid,
        ...feat.properties
      }))
      .sort(sortByKey('value'))
      .slice(0, 10);

    return topTenAreas.map((d, i) => {
      const icon = L.divIcon({
        className: 'rankingmarker',
        html: `<div>${i + 1}.</div>`,
        iconSize: [MARKER_SIZE, MARKER_SIZE],
        iconAnchor: [MARKER_SIZE / 2, MARKER_SIZE / 2]
      });
      return (
        <Marker
          key={`RankingMarker__${i}`}
          position={d.centroid}
          icon={icon}
        />
      );
    });
  }
}

export default RankingMarker;
